// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__nkdZF","list":"BalanceDue_list__3XUgc","listRow":"BalanceDue_listRow__1uHgg","total":"BalanceDue_total__3O3nr"};